<template>
    <div class="public_container">

            <div class="mobile_login_container">
                <div class="phone_login_board">
                    <img alt="" src="https://download.hecoos.com/enlightv/2024-32/xsYhfHKXPAECwMcAJFRD.png" class="sass_icon">
                    <ul  class="login_type_list bottom_border_30">
                        <li class="login_type_item active">绑定手机号</li>
                    </ul>
                    <el-form :model="bindingFrom" :rules="bindingFromRules"  ref="bindingFrom">
                        <el-form-item prop="phone">
                            <el-input placeholder="手机号" v-model="bindingFrom.phone"></el-input>
                        </el-form-item>
                        <el-form-item prop="code">
                            <el-input maxlength="6" placeholder="验证码" v-model="bindingFrom.code">
                                <el-button :disabled="getCodeBtnDisabled1" @click="handleClickGetCode()"
                                           slot="suffix"
                                           type="text">
                                    {{getCodeText1}}
                                </el-button>
                            </el-input>
                        </el-form-item>

                        <el-form-item>
                            <el-button @click="handleClickConfirm()" :disabled="btnDisabled" class="login_btn" type="primary">绑定</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>

    </div>
</template>
<script>
import { SendPhoneCode,GetUserInfo,bindPhone} from "@/api/index";
import ReturnNavBar from '@/components/mComponents/ReturnNavBar.vue'
export default {
    name: 'mobileReplacePhone',
    data () {
        return {
            btnDisabled:false,
            bindingFrom:{
                phone:'',
                code:'',
            },
            bindingFromRules: {
                phone: [
                    {
                        required: true,
                        trigger: 'blur',
                        validator: (rule, value, callback) => {
                            if (!value) return callback(new Error('请输入手机号'))
                            if (!/^1[3456789]\d{9}$/.test(value)) return callback(new Error('请输入正确的手机号'))
                            callback()
                        }
                    },
                ],
                code: [
                    {
                        required: true,
                        trigger: 'blur',
                        validator: (rule, value, callback) => {
                            if (!value) return callback(new Error('请输入验证码'))
                            if (!/^\d{6}$/.test(value)) return callback(new Error('请输入6位验证码'))
                            callback()
                        }
                    },
                ],
            },
            getCodeBtnDisabled1:false,
            getCodeTime1:60,
        }
    },
    computed: {
        getCodeText1() {
            if (this.getCodeBtnDisabled1) {
                return `${this.getCodeTime1}秒后重新发送`;
            } else {
                return '获取验证码';
            }
        },

    },
    created() {

    },
    mounted () {

    },
    methods: {

        // 获取验证码
        handleClickGetCode(type){
            if (!this.bindingFrom.phone) {
                return this.$toast('请输入手机号')
            }
            SendPhoneCode({
                phone: this.bindingFrom.phone,
                type: "bind_phone"
            }).then(res => {
                if (res.code === 200) {
                    this.$toast('验证码发送成功')
                    this.getCodeBtnDisabled1 = true;
                    const timer = setInterval(() => {
                        if (this.getCodeTime1 > 0) {
                            this.getCodeTime1--;
                        } else {
                            this.getCodeBtnDisabled1 = false;
                            clearInterval(timer);
                            this.getCodeTime1 = 60;
                        }
                    }, 1000);
                } else {
                    this.$toast(res.message)
                }
            })
        },
        handleClickConfirm(){
            this.$refs.bindingFrom.validate((valid) => {
                if (valid) {
                    let avatar = this.$route.query.avatar
                    let name = this.$route.query.name
                    let openid = this.$route.query.openid
                    let gender = this.$route.query.gender
                    let postData = {
                        avatar,
                        name,
                        openid,
                        gender,
                        phone: this.bindingFrom.phone,
                        code: this.bindingFrom.code
                    }
                    this.btnDisabled = true
                    bindPhone(postData).then(res => {
                        if (res.code === 200) {
                            const { user } = res.data
                            if (user && user.token) {
                                this.$store.dispatch("saveUserInfo", user);
                                this.$toast({
                                    message: "绑定成功",
                                    type: "success",
                                    duration: 1000,
                                    onClose: () => {
                                        if(user.company_id){
                                            this.$router.push({
                                                name: 'mobileWorkBench'
                                            })
                                        }else{
                                            this.$router.push({
                                                name: 'mobileNoCompany'
                                            })
                                        }
                                        this.btnDisabled = false
                                    },
                                });
                            }else{
                                this.btnDisabled = false
                            }
                        }else{
                            this.btnDisabled = false
                        }
                    })
                }
            })
        },

    },
    components: {
        ReturnNavBar
    }
}
</script>

<style lang="scss" scoped>

</style>
